<template>
	<div class="pa-2">
		<v-row dense>
			<!-- image -->
			<v-col
				class="border opacity-40"
				cols="5"
				sm="2"
				md="2">
				<v-sheet style="height: 150px; position: relative">
					<v-img
						src="@/assets/profile.png"
						height="100%"
						contain></v-img>
				</v-sheet>
			</v-col>

			<v-col
				class="border"
				cols="7"
				sm="10"
				md="10">
				<!-- personal info -->
				<v-row
					dense
					class="opacity-40">
					<!-- full name -->
					<v-col
						cols="12"
						sm="6"
						md="3">
						<v-text-field
							disabled
							:label="$T('personal.name')"
							outlined
							dense
							hide-details></v-text-field>
					</v-col>
					<!-- name in english -->
					<v-col
						cols="12"
						sm="6"
						md="3">
						<v-text-field
							disabled
							:label="$T('personal.nameInEnglish')"
							outlined
							dense
							hide-details></v-text-field>
					</v-col>
					<!-- father and mother -->
					<v-col
						class="d-flex"
						cols="12"
						sm="6"
						md="3">
						<v-text-field
							disabled
							class="pe-2"
							:label="$T('personal.fatherName')"
							outlined
							dense
							hide-details></v-text-field>
						<v-text-field
							disabled
							:label="$T('personal.motherName')"
							outlined
							dense
							hide-details></v-text-field>
					</v-col>
					<!-- national id -->
					<v-col
						cols="12"
						sm="6"
						md="3">
						<v-text-field
							disabled
							:label="$T('personal.nationalId')"
							outlined
							dense
							hide-details></v-text-field>
					</v-col>
					<!-- sex -->
					<v-col
						cols="12"
						sm="6"
						md="2">
						<v-radio-group
							disabled
							class="mt-1"
							row
							dense
							hide-details>
							<v-radio
								:label="$T('personal.male')"
								value="1"></v-radio>
							<v-radio
								:label="$T('personal.female')"
								value="2"></v-radio>
						</v-radio-group>
					</v-col>
					<!-- nationality -->
					<v-col
						cols="12"
						sm="6"
						md="2">
						<v-text-field
							disabled
							:label="$T('personal.nationality')"
							outlined
							dense
							hide-details></v-text-field>
					</v-col>
					<!-- state -->
					<v-col
						cols="12"
						sm="6"
						md="2">
						<v-text-field
							disabled
							:label="$T('personal.state')"
							outlined
							dense
							hide-details></v-text-field>
					</v-col>
					<!-- birth location -->
					<v-col
						cols="12"
						sm="6"
						md="3">
						<v-text-field
							disabled
							:label="$T('personal.birthLocation')"
							outlined
							dense
							hide-details></v-text-field>
					</v-col>
					<!-- birthday -->
					<v-col
						cols="12"
						sm="6"
						md="2">
						<bee-date-picker
							disabled
							:input-label="$T('personal.birthday')"
							outlined
							menu-picker
							:input-props="{
								outlined: true,
								dense: true,
								prependInnerIcon: '$calendar',
							}"
							no-title
							dense
							hide-details></bee-date-picker>
					</v-col>
					<!-- age -->
					<v-col
						cols="12"
						sm="6"
						md="1">
						<v-text-field
							:label="$T('personal.age')"
							disabled
							outlined
							dense
							hide-details></v-text-field>
					</v-col>
				</v-row>

				<!-- statues -->
				<v-row
					dense
					class="mb-1 opacity-40">
					<!-- miliary statue -->
					<v-col cols="6">
						<span class="text-caption text--secondary">
							{{ $T('societyStatus.militaryability') }}
						</span>
						<div class="d-block d-md-flex">
							<v-radio-group
								disabled
								class="mt-1"
								row
								dense
								hide-details>
								<v-radio
									:label="$T('societyStatus.militaryStatus.done')"
									value="1"></v-radio>
								<v-radio
									:label="$T('societyStatus.militaryStatus.exempt')"
									value="2"></v-radio>
								<v-radio
									:label="$T('societyStatus.militaryStatus.postponed')"
									value="3"></v-radio>
							</v-radio-group>
						</div>
					</v-col>
					<!-- social statue -->
					<v-col cols="6">
						<span class="text-caption text--secondary">
							{{ $T('societyStatus.marriageability') }}
						</span>
						<div class="d-block d-md-flex">
							<v-radio-group
								disabled
								class="mt-1"
								row
								dense
								hide-details>
								<v-radio
									:label="$T('societyStatus.marriageStatus.marriage')"
									value="1"></v-radio>
								<v-radio
									:label="$T('societyStatus.marriageStatus.divorced')"
									value="2"></v-radio>
								<v-radio
									:label="$T('societyStatus.marriageStatus.single')"
									value="3"></v-radio>
							</v-radio-group>

							<v-text-field
								style="max-width: 9rem; margin-right: 10px"
								disabled
								:label="$T('societyStatus.childNumber')"
								:rules="[(e) => typeof e === 'number']"
								validate-on-blur
								outlined
								dense
								hide-details></v-text-field>
						</div>
					</v-col>
				</v-row>

				<span class="text-caption text--secondary">
					{{ $T('other') }}
				</span>
				<v-row
					dense
					align="center">
					<v-col
						v-for="(item, i) in newFiled"
						:key="i"
						cols="12"
						sm="6"
						md="3">
						<v-text-field
							v-if="item.type === typesEnum.text"
							v-model="item.value"
							:label="item.name"
							outlined
							dense
							hide-details></v-text-field>
						<bee-date-picker
							v-else-if="item.type === typesEnum.date"
							:active-picker.sync="activePicker"
							v-model="item.value"
							:input-label="item.name"
							outlined
							menu-picker
							:input-props="{
								outlined: true,
								dense: true,
								prependInnerIcon: '$calendar',
							}"
							no-title
							dense
							hide-details></bee-date-picker>
						<v-radio-group
							v-else-if="item.type === typesEnum.radio"
							v-model="item.value"
							:label="item.name"
							class="mt-1"
							row
							dense
							hide-details>
							<v-radio
								v-for="(option, i) in item.options"
								:key="i + ' option'"
								:label="option"
								:value="option"></v-radio>
						</v-radio-group>
					</v-col>
					<v-col
						cols="12"
						sm="6"
						md="3">
						<v-btn
							color="primary"
							@click="addFieldDialog = true">
							<v-icon left>$add</v-icon>
							{{ $T('addInformation.addField.options') }}
						</v-btn>
					</v-col>
				</v-row>
			</v-col>

			<!-- contacts info -->
			<v-col
				class="border opacity-40"
				cols="12"
				sm="6"
				md="7">
				<strong class="d-block mb-2">{{ $T('contactsInfo.title') }}</strong>
				<bee-handy-smart-table
					ref="contactsTable"
					:headers="contactsHeader"
					:items="contactsItems"
					:items-per-page="-1"
					:data-table-props="{ disableSort: true }"
					elevation="1"
					dense
					editable-rows
					hide-no-data-area
					show-add-row
					hide-default-header
					hide-default-footer
					fixed-header
					hide-inputs-details
					stay-in-input-fields>
					<template v-slot:input.key="{ on, attr }">
						<v-autocomplete
							disabled
							v-on="on"
							v-bind="attr"
							item-text="text"
							return-object></v-autocomplete>
					</template>
					<template v-slot:no-input.actions="{}">
						<v-btn
							disabled
							icon
							small
							color="success">
							<v-icon
								size="20"
								color="addRow">
								$addRow
							</v-icon>
						</v-btn>
					</template>
				</bee-handy-smart-table>
			</v-col>

			<!-- health info -->
			<v-col
				class="border"
				cols="12"
				sm="6"
				md="5">
				<div class="opacity-40">
					<strong class="d-block mb-2">{{ $T('healthInfo.title') }}</strong>
					<!-- haveIllness -->
					<span class="font-weight-bold text-caption mt-3 d-block">{{
						$T('healthInfo.haveIllness')
					}}</span>
					<v-row
						align="center"
						dense>
						<v-col
							cols="12"
							sm="4">
							<v-radio-group
								disabled
								class="mt-1"
								row
								dense
								hide-details>
								<v-radio
									:label="$T('no')"
									:value="false"></v-radio>
								<v-radio
									:label="$T('yes')"
									:value="true"></v-radio>
							</v-radio-group>
						</v-col>
						<v-col
							cols="12"
							sm="8">
							<v-text-field
								disabled
								:label="$T('healthInfo.description')"
								outlined
								dense
								hide-details></v-text-field>
						</v-col>
					</v-row>

					<!-- haveSurgery -->
					<span class="font-weight-bold text-caption mt-3 d-block">{{
						$T('healthInfo.haveSurgery')
					}}</span>
					<v-row
						align="center"
						dense>
						<v-col
							cols="12"
							sm="4">
							<v-radio-group
								disabled
								class="mt-1"
								row
								dense
								hide-details>
								<v-radio
									:label="$T('no')"
									:value="false"></v-radio>
								<v-radio
									:label="$T('yes')"
									:value="true"></v-radio>
							</v-radio-group>
						</v-col>
						<v-col
							cols="12"
							sm="8">
							<v-text-field
								disabled
								:label="$T('healthInfo.description')"
								outlined
								dense
								hide-details></v-text-field>
						</v-col>
					</v-row>

					<!-- haveAllergy -->
					<span class="font-weight-bold text-caption mt-3 d-block">{{
						$T('healthInfo.haveAllergy')
					}}</span>
					<v-row
						align="center"
						dense>
						<v-col
							cols="12"
							sm="4">
							<v-radio-group
								disabled
								class="mt-1"
								row
								dense
								hide-details>
								<v-radio
									:label="$T('no')"
									:value="false"></v-radio>
								<v-radio
									:label="$T('yes')"
									:value="true"></v-radio>
							</v-radio-group>
						</v-col>
						<v-col
							cols="12"
							sm="8">
							<v-text-field
								disabled
								:label="$T('healthInfo.description')"
								outlined
								dense
								hide-details></v-text-field>
						</v-col>
					</v-row>

					<!-- smoking -->
					<span class="font-weight-bold text-caption mt-3 d-block">{{
						$T('healthInfo.smoking')
					}}</span>
					<v-row
						align="center"
						dense>
						<v-col
							cols="12"
							sm="4">
							<v-radio-group
								disabled
								class="mt-1"
								row
								dense
								hide-details>
								<v-radio
									:label="$T('no')"
									:value="false"></v-radio>
								<v-radio
									:label="$T('yes')"
									:value="true"></v-radio>
							</v-radio-group>
						</v-col>
					</v-row>
				</div>

				<template v-for="(medical, i) in newMedical">
					<span
						class="font-weight-bold text-caption mt-3 d-block"
						:key="i + 'q'">
						{{ medical.name }}
					</span>
					<v-row
						align="center"
						dense
						:key="i + 'a'">
						<v-col
							cols="12"
							sm="4">
							<v-radio-group
								v-model="medical.value"
								class="mt-1"
								row
								dense
								hide-details>
								<v-radio
									:label="$T('no')"
									:value="false"></v-radio>
								<v-radio
									:label="$T('yes')"
									:value="true"></v-radio>
							</v-radio-group>
						</v-col>
						<v-col
							v-if="medical.type !== medicalTypesEnum.none"
							cols="12"
							sm="8">
							<v-text-field
								:disabled="
									medical.value === null ||
									(medical.type === medicalTypesEnum.onYes && !medical.value) ||
									(medical.type === medicalTypesEnum.onNo && medical.value)
								"
								:label="$T('healthInfo.description')"
								outlined
								dense
								hide-details></v-text-field>
						</v-col>
					</v-row>
				</template>
				<v-btn
					class="mt-3"
					color="primary"
					@click="addMedicalDialog = true">
					<v-icon left>$add</v-icon>
					{{ $T('addInformation.addMedical.button') }}
				</v-btn>
			</v-col>
		</v-row>

		<v-dialog
			v-model="addFieldDialog"
			persistent
			max-width="500">
			<v-card elevation="3">
				<v-form>
					<v-card-title primary-title>
						{{ $T('addInformation.addField.title') }}
						<v-spacer></v-spacer>
						<v-btn
							@click="addFieldDialog = false"
							icon>
							<v-icon color="alert-color">mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row dense>
							<v-col cols="6">
								<v-text-field
									v-model="fieldItem.name"
									:label="$T('addInformation.addField.name')"
									outlined
									dense
									hide-details></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-select
									v-model="fieldItem.type"
									:items="Object.values(fieldItems)"
									:label="$T('addInformation.addField.type')"
									outlined
									dense
									hide-details></v-select>
							</v-col>
							<v-col cols="12">
								<v-text-field
									v-if="fieldItem.type === detailsType.options"
									v-model="fieldItem.options"
									:label="$T('addInformation.addField.options')"
									outlined
									dense
									:hint="$T('addInformation.addField.optionsHind')"
									persistent-hint></v-text-field>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions class="align-center">
						<v-spacer></v-spacer>
						<v-btn
							:disabled="cantAddField"
							color="secondary"
							@click="addNewField">
							{{ $T('default-buttons.save') }}
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="addMedicalDialog"
			persistent
			max-width="500">
			<v-card elevation="3">
				<v-form>
					<v-card-title primary-title>
						{{ $T('addInformation.addMedical.title') }}
						<v-spacer></v-spacer>
						<v-btn
							@click="addMedicalDialog = false"
							icon>
							<v-icon color="alert-color">mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row dense>
							<v-col cols="6">
								<v-text-field
									v-model="medicalItem.name"
									:label="$T('addInformation.addMedical.question')"
									outlined
									dense
									hide-details></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-select
									v-model="medicalItem.type"
									:items="Object.values(medicalsItem)"
									:label="$T('addInformation.addMedical.type')"
									outlined
									dense
									hide-details></v-select>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions class="align-center">
						<v-spacer></v-spacer>
						<v-btn
							:disabled="cantAddMedical"
							color="secondary"
							@click="
								addMedicalDialog = false;
								addNewMedical();
							">
							{{ $T('default-buttons.save') }}
						</v-btn>
					</v-card-actions>
				</v-form>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { detailsType } from '@/utils/enum';
import  firebase from '@/firebase'
// import { personal } from '@/api';

const typesEnum = {
	text: 0,
	date: 1,
	radio: 2,
};
const medicalTypesEnum = {
	onYes: 0,
	onNo: 1,
	none: 2,
};

export default {
	name: 'PersonalInfo',

	data() {
		return {
			firebase,
			activePicker: null,
			addFieldDialog: false,
			addMedicalDialog: false,

			fieldItems: [
				{
					text: this.$T('addInformation.addField.types.text'),
					value: detailsType.text,
				},
				{
					text: this.$T('addInformation.addField.types.date'),
					value: detailsType.date,
				},
				{
					text: this.$T('addInformation.addField.types.radio'),
					value: detailsType.options,
				},
			],
			fieldItem: {
				name: null,
				type: null,
				options: null,
			},
			newFiled: [],

			medicalsItem: [
				{
					text: this.$T('addInformation.addMedical.types.onYes'),
					value: medicalTypesEnum.onYes,
				},
				{
					text: this.$T('addInformation.addMedical.types.onNo'),
					value: medicalTypesEnum.onNo,
				},
				{
					text: this.$T('addInformation.addMedical.types.none'),
					value: medicalTypesEnum.none,
				},
			],
			medicalItem: {
				name: null,
				type: null,
				value: null,
			},
			newMedical: [],

			typesEnum,
			medicalTypesEnum,
			detailsType,

			contactsHeader: [
				{
					text: '',
					name: 'key',
					value: 'key',
					setValueExpr: (value) => value.text,
					sortable: false,
					width: 200,
				},
				{ text: '', name: 'value', value: 'value', sortable: false, disableInput: true },
				{
					text: '',
					name: 'actions',
					value: 'actions',
					noInput: true,
					width: 20,
				},
			],
			contactsItems: [],
		};
	},

	computed: {
		cantAddField() {
			return (
				!this.fieldItem.name ||
				this.fieldItem.type === null ||
				(this.fieldItem.type === detailsType.options && !this.fieldItem.options)
			);
		},
		cantAddMedical() {
			return !this.medicalItem.name || this.medicalItem.type === null;
		},
	},

	methods: {
		addNewField() {
			if (this.cantAddField) return;

			if (!this.fieldItem.type !== detailsType.options) {
				this.newFiled.push(this.fieldItem);
			} else {
				const options = this.fieldItem.options
					.split('-')
					.map((e) => e.trim())
					.filter((e) => !!e);
				this.newFiled.push({ ...this.fieldItem, options: options });
			}

			this.fieldItem = {
				name: null,
				type: null,
				options: null,
			};
			this.addFieldDialog = false;
		},

		addNewMedical() {
			if (this.cantAddMedical) return;
			this.newMedical.push(this.medicalItem);
			this.medicalItem = {
				name: null,
				type: null,
				value: null,
			};
			return 1;
		},
	},

	mounted() {
		this.$store.dispatch('employee/addDetail').then((res) => {
			console.log(res);
		});
	},
};
</script>

<style lang="scss" scoped>
.opacity-40 {
	opacity: 40%;
}
</style>
